import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from '../../Configuration/configuration.service';


@Injectable({
  providedIn: 'root'
})
export class ComputationsService {

  profitAndLossUrl = this.configService.getAPIBaseUrl() + 'api/ProfitandLoss/';
  balancingcahrgeUrl = this.configService.getAPIBaseUrl() + 'api/CapitalAllowences/'
  mechinaryUrl = this.configService.getAPIBaseUrl() + 'api/Computations_MachineryandPlant/'
  tradingLossUrl = this.configService.getAPIBaseUrl() +'api/TradingLoss/'
  adjustmentsUrl = this.configService.getAPIBaseUrl() +'api/Adjustments/';
  tradingProfitOrLossUrl = this.configService.getAPIBaseUrl() +'api/AdjustedTradingProfitLoss/';
  summaryUrl = this.configService.getAPIBaseUrl() +'api/Computations_Summary/';
  researchandDevelopmentUrl = this.configService.getAPIBaseUrl() +'api/Computations_ResearchandDevelopmentAllowances/';
  otherCapitalAllowanceUrl = this.configService.getAPIBaseUrl() +'api/Computations_OtherCapitalAllowances/';
  profitsChargeableUrl = this.configService.getAPIBaseUrl() +'api/ProfitsChargeabletoCorporationTax/';
  figuresValidatedUrl = this.configService.getAPIBaseUrl() +'api/Computations_FiguresTransferred/';
 
  CapitalsummeryUrl = this.configService.getAPIBaseUrl() + 'api/CapitalAllowancesandBalancingCharges/'
    constructor(private http: HttpClient, private configService: ConfigurationService) { }

  getProfitAndLoss(APPeriodId) {
    return this.http.get(this.profitAndLossUrl + "GetProfitandLoss?APPeriodId=" + APPeriodId);
  }

  insertProfitAndLoss(data) {
    return this.http.post(this.profitAndLossUrl + 'InsertProfitandLoss', data)
  }
  getAdjustmentsData(APPeriodId) {
    return this.http.get(this.adjustmentsUrl + 'GetAdjustments?APPeriodId=' + APPeriodId)
  }
  insertAdjustments(data) {
    return this.http.post(this.adjustmentsUrl + 'InsertAdjustments',data)
  }
  getTradingProfitOrLoss(APPeriodId) {
    return this.http.get(this.tradingProfitOrLossUrl + 'GetTradingProfitLoss?id=' + APPeriodId)
  }
  insertTradingProfitOrLoss(data) {
    return this.http.post(this.tradingProfitOrLossUrl +'Inserttradingprofitloss',data)
  }
  getSummaryData(APPeriodId) {
    return this.http.get(this.summaryUrl + 'GetComputationsSummary?APPeriodId=' + APPeriodId)
  }
  insertSummaryData(data) {
    return this.http.post(this.summaryUrl + 'InsertComputations_Summary' ,data)
  }
  getResearchandDevelpoment(ComputationAPPeriodId) {
    return this.http.get(this.researchandDevelopmentUrl + 'GetComputationsResearchandDevelopmentAllowances?ComputationAPPeriodId=' + ComputationAPPeriodId)
  }
  insertResearchandDevelpoment(data) {
    return this.http.post(this.researchandDevelopmentUrl +'InsertComputationsResearchandDevelopmentAllowances',data)
  }
  getOtherCapitalAllowance(APPeriodId) {
    return this.http.get(this.otherCapitalAllowanceUrl + 'GetComputationsOtherCapitalAllowances?APPeriodId=' + APPeriodId)
  }
  insertOtherCapitalAllowance(data) {
    return this.http.post(this.otherCapitalAllowanceUrl +'InsertComputationsOtherCapitalAllowances',data)
  }
  getProfitIncome(APPeriodId) {
    return this.http.get(this.profitAndLossUrl + "getprofitdata/" + APPeriodId);
  }
  insertIncomedata(data) {
    const httpOptions = { headers: new HttpHeaders({ 'content-type': 'text/json' }) }
    return this.http.post(this.profitAndLossUrl + "insertprofitdata", data, httpOptions)
  }
  getbalancingchargesdata(APPeriodId) {
    return this.http.get(this.balancingcahrgeUrl + 'getAllowencedata/' + APPeriodId)
  }
  insertbalancingchargesdata(data) {
    const httpOptions = { headers: new HttpHeaders({ 'content-type': 'text/json' }) }
    return this.http.post(this.balancingcahrgeUrl + 'InsertAllowencedata', data, httpOptions)
  }
  insertMechinaryplantData(data) {
    const httpOptions = { headers: new HttpHeaders({ 'content-type': 'text/json' }) }
    return this.http.post(this.mechinaryUrl + 'InsertComputationsMachineryandPlant', data, httpOptions)
  }
  getMechinaryplantData(id) {
    return this.http.get(this.mechinaryUrl + 'GetComputationsMachineryandPlant?APPeriodId=' + id);
  }
  getTradedata(id) {
    return this.http.get(this.tradingLossUrl + 'GetTradeloss?id=' + id);
  }
  inserttradedata(data) {
    const httpOptions = { headers: new HttpHeaders({ 'content-type': 'text/json' }) }
    return this.http.post(this.tradingLossUrl + 'InsertyTradelossdata', data, httpOptions)
  }
  getCaptialbalancechargedata(id) {
    return this.http.get(this.CapitalsummeryUrl +'CapitalAllowancesandBalancingCharges?id='+id)
  }
  insertCaptialbalancechargedata(data) {
    const httpOptions = { headers: new HttpHeaders({ 'content-type': 'text/json' }) }
    return this.http.post(this.CapitalsummeryUrl + 'InsertCapitalAllowancesandBalancingCharges', data, httpOptions)
  }
  getProfitsChargeable(APPeriodId) {
    return this.http.get(this.profitsChargeableUrl + 'GetProfitsChargeabletoCorporationTax?APPeriodId=' + APPeriodId)
  }
  insertProfitsChargeable(data) {
    return this.http.post(this.profitsChargeableUrl +'InsertProfitsChargeabletoCorporationTax',data)
  }
  getFiguresValidated(APPeriodId) {
    return this.http.get(this.figuresValidatedUrl + 'GetComputations_FiguresTransferred?id=' + APPeriodId)
  }
  insertFiguresValidated(data) {
    return this.http.post(this.figuresValidatedUrl +'InsertComputations_FiguresTransferred',data)
  }
  insertCapitalAllowance(data) {
    return this.http.post(this.adjustmentsUrl + 'InsertCapitalAllowance', data)
  }
  getCapitalAllowance(APPeriodId) {
    return this.http.get(this.adjustmentsUrl + 'GetCapitalAllowance?APPeriodId=' + APPeriodId)
  }
  getMRRdata(data) {
    return this.http.post(this.adjustmentsUrl +'getMRRdata',data)
  }
  getComputationsData(APPeriodId) {
    return this.http.get(this.adjustmentsUrl + 'getComputations?APPeriodId=' + APPeriodId)
  }
}
